export default "__VITE_ASSET__d9af8a07__"